import Feature2025summerController from "./feature2025summer_controller"
application.register("feature2025summer", Feature2025summerController)
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import CalendarScrollController from "./calendar_scroll_controller"
application.register("calendar-scroll", CalendarScrollController)

import CompanyCardController from "./company_card_controller"
application.register("company-card", CompanyCardController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmployeeVoiceModalController from "./employee_voice_modal_controller"
application.register("employee-voice-modal", EmployeeVoiceModalController)

import GuideScrollController from "./guide_scroll_controller"
application.register("guide-scroll", GuideScrollController)

import EventScheduleController from "./event_schedule_controller"
application.register("event-schedule", EventScheduleController)

import Feature2018Controller from "./feature2018_controller"
application.register("feature2018", Feature2018Controller)

import HamburgerController from "./hamburger_controller"
application.register("hamburger", HamburgerController)

import HeaderSearchController from "./header_search_controller"
application.register("header-search", HeaderSearchController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiSelectDropdownController from "./multi_select_dropdown_controller"
application.register("multi-select-dropdown", MultiSelectDropdownController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import RecruitModalController from "./recruit_modal_controller"
application.register("recruit-modal", RecruitModalController)

import Winter2020Controller from "./winter2020_controller"
application.register("winter2020", Winter2020Controller)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SearchOverlayController from "./search_overlay_controller"
application.register("search-overlay", SearchOverlayController)

import SlideshowController from "./slideshow_controller"
application.register("slideshow", SlideshowController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
